import React from "react";
import {
  QueryV2ProtocolData,
  QueryV2Connection,
  SubscribeV2ProtocolData,
} from "../../../utils/graphql/hooks/aksHooks";

export default function TimingDataManager() {
  QueryV2Connection();
  SubscribeV2ProtocolData();
  QueryV2ProtocolData();
  return <></>;
}
